import { useSelector } from "react-redux";
import Admin from "./pages/Admin";
import Auth from "./pages/Auth";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";
function App() {
  const user = useSelector((state) => state.user.user);
  return (
    <div className="App">
      <Toaster position="top-right" reverseOrder={false} />
      <Router>
        <Routes>
          <Route path="/" element={<Auth />} />
          <Route path="/admin" element={user?<Admin />:<Auth/>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
